import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Core2Config } from '../shared/core2Config';
import { OCRGenericDocContainerModel, OCRGenericDocDetailsContainerModel } from "../../../../../models";
import { ApiVisa, BasicApiResponseModel, Pagination, PagingResponseModel } from '../shared';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';
import { Observable } from 'rxjs';

// https://api.akaun.dev/core2/platform/dm/tenants/tenant-users

@Injectable({
  providedIn: 'root'
})

export class OCRGenericDocService extends BaseApiPublicLoginTemplateService<OCRGenericDocContainerModel, OCRGenericDocContainerModel, OCRGenericDocContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'ocr/generic-documents/backoffice-ep';
  readonly url2 = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'ocr/generic-documents/';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'ocr/generic-documents/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'ocr/generic-documents/backoffice-ep';
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'ocr/generic-documents/' + BaseApiPublicLoginTemplateService.LOGIN_ENTITY_EP;
    this.httpClient = http;
  }

  updatePostingStatus(dtoObject: Object, apiVisa: ApiVisa, guid: string) {
    let updatedPath ;
    if (this.endpoint_path && apiVisa.api_domain_url) {
      updatedPath = apiVisa.api_domain_url + this.url2+ 'update-posting-status/backoffice-ep/' + guid;
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.put<BasicApiResponseModel<OCRGenericDocContainerModel>>(
      updatedPath,
      dtoObject,
      this.getHttpHeader(apiVisa)
    );
  }

  public getBySnapshotCustomQuery(dtoObject: any, visa: ApiVisa): Observable<PagingResponseModel<OCRGenericDocContainerModel>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.url2 + 'custom/query/snapshot/backoffice-ep';
    }
    return this.httpClient.post<PagingResponseModel<OCRGenericDocContainerModel>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
 
  public getBySnapshotDetailsCustomQuery(dtoObject: any, visa: ApiVisa): Observable<PagingResponseModel<OCRGenericDocDetailsContainerModel>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.url2 + 'with-details/custom/query/snapshot/backoffice-ep';
    }
    return this.httpClient.post<PagingResponseModel<OCRGenericDocDetailsContainerModel>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public getCountByCustomQuery(pagination: Pagination, visa: ApiVisa): Observable<BasicApiResponseModel<number>> {
    let url;
    if (visa.api_domain_url) {
      url = visa.api_domain_url + this.url2 + 'with-details/custom/query/count/backoffice-ep';
    }

    const UrlByCriteria =
      url + '?' + pagination.getQueryKeyValues();
    return this.httpClient.get<BasicApiResponseModel<number>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }
}

